import React, { useCallback } from 'react';
import ReactDOM from 'react-dom';
import styles from './Header.module.css';

interface HeaderOverlayProps {
  onClick: () => void;
}

const HeaderOverlay: React.FC<HeaderOverlayProps> = ({ onClick }) => {
  // クリックハンドラをuseCallbackでラップして最適化
  const handleClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation(); // クリックイベントの伝播を止める
    e.preventDefault(); // デフォルト動作も防止
    onClick();
  }, [onClick]);

  const portal = (
    <div 
      className={styles.headerMenuOverlay}
      onClick={handleClick}
      data-testid="header__menu-overlay"
    />
  );

  // Portalを使用してbodyに直接マウント
  return ReactDOM.createPortal(portal, document.body);
};

export default HeaderOverlay; 